import React from 'react';
import { AccountDropdownProvider } from 'src/features/header/components/AccountDropdown/AccountDropdownProvider';
import { MobileAccountSwitcherSection } from 'src/features/header/MobileAccountSwitcherSection';
import { MobileAccountSwitcherOverlay } from 'src/features/header/MobileAccountSwitcherOverlay';
import MobileBreadcrumb from 'src/features/header/components/BreadcrumbIA2/MobileBreadcrumb';
import { useInternalChromeConfigContext } from 'src/providers/InternalChromeConfigContextProvider';
import { AccountSwitcherPublisher } from 'src/commons/utils/metrics';
import { useChromeConfigContext } from 'src/providers/ChromeConfigContextProvider';
import { selectIsMobileWebView } from 'src/app/slice';
import { useSelector } from 'react-redux';

const GlobalNonStickyMobileHeader: React.FC = () => {
  const chromeConfig = useChromeConfigContext();
  const { config: internalChromeConfig } = useInternalChromeConfigContext();
  const { isInterstitialPage } = internalChromeConfig;
  const isMobileWebView = useSelector(selectIsMobileWebView);
  const breadcrumbs = chromeConfig.breadcrumbs || [];
  const breadcrumb =
    breadcrumbs.length > 0 ? breadcrumbs[breadcrumbs.length - 1] : null;
  const [isAccountSwitcherOpen, setIsAccountSwitcherOpen] =
    React.useState(false);

  const handleAccountSwitcherClose = () => {
    AccountSwitcherPublisher.publishCounterMonitor('Close', 1);
    setIsAccountSwitcherOpen(false);
  };

  return (
    <div id="console-non-sticky-mobile-header">
      {!isInterstitialPage && !isMobileWebView && (
        <AccountDropdownProvider>
          <MobileAccountSwitcherSection
            handleToggle={() => setIsAccountSwitcherOpen(true)}
          />
          <MobileAccountSwitcherOverlay
            isOpen={isAccountSwitcherOpen}
            handleClose={handleAccountSwitcherClose}
          />
        </AccountDropdownProvider>
      )}
      {breadcrumb && <MobileBreadcrumb breadcrumb={breadcrumb} />}
    </div>
  );
};

export default GlobalNonStickyMobileHeader;
